export default class TextValidate {
    static init(): void {
        const textNodes: NodeListOf<HTMLParagraphElement> = document.querySelectorAll('.js-validate-text');

        if (textNodes.length > 0) {
            textNodes.forEach((node: HTMLParagraphElement) => {
                node.innerHTML = node.innerHTML.replace(/\b(a|s|o|u|k|i|v|z)\s/g, '$1&nbsp;');
            });
        }
    }
}